<div class="container-fluid">
    <!-- Selecting questions by lecture -->
    <div class="p-3">
        <mat-form-field appearance="fill" class="w-100">
            <mat-label>Select by lecture</mat-label>
            <mat-select name="Lectures" [(ngModel)]="selectedOption" (ngModelChange)="selectByLecture()">
                <mat-option value="0">This Lecture</mat-option>
                <mat-option value="1">All Lectures</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <!--  -->

    <!-- For empty Question -->
    <div *ngIf="emptyQuestion">
        <p class="text-center">{{message}}</p>
    </div>
    <!--  -->

    <!-- spinner -->
    <div align="center" *ngIf="spinner">
        <mat-spinner [diameter]="30"></mat-spinner>
    </div>
    <!--  -->

    <!-- For displaying questions -->
    <div class="row" style="height: 50vh; max-height: 50vh; overflow: auto;">
        <div class="col-12">
            <div class="row card shadow border mb-3 mx-3 p-2" *ngFor="let question of allQuestions">
                <div class="col-12 mx-auto"
                    (click)="addResponse(question.resource_question_id, question.question_title, question.question, question.resource)">
                    <div class="row mb-0">
                        <div class="col-8">
                            <div class="d-flex">
                                <div>
                                    <mat-icon class="mr-3 mt-2" style="font-size: 25pt;">account_circle_full</mat-icon>
                                </div>
                                <div>
                                    <span>{{question.firstname}} {{question.lastname}}</span><br>
                                    <span style="font-size: 9pt;">{{question.created_at}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-4">
                            <div>
                                <small style="color: #070e4e"><b>{{question.response_count}} responses</b></small>
                            </div>
                        </div>
                    </div>
                    <div class="mt-1">
                        <div *ngIf="question.question_type == 0">
                            <span style="font-size: 9pt;" class="text-muted">Topic: {{question.topic}}</span><br>
                            <span style="font-size: 9pt;" class="text-muted">Lecture: {{question.resource}}</span>
                        </div>
                        <div *ngIf="question.question_type == 1">
                            <span style="font-size: 11pt;" class="text-muted"><b>General Question</b></span>
                        </div>
                        <!-- <hr> -->
                        <h6 class="mt-1">{{question.question_title | uppercase}}</h6>
                        <p>{{question.question}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--  -->

    <!-- For adding notes -->
    <div class="row" style="width: 95% !important;">
        <div class="col-12" align="right">
            <mat-icon class="material-symbols-outlined" style="font-size: 50px; cursor: pointer;"
                (click)="addQuestions()">
                add_circle
            </mat-icon>
        </div>
    </div>
    <!--  -->
</div>